export const GRAPHQL_VARIABLES = {
  record: {
    vendorId: '5fc44ddb84ffd06759c1a1ef',
    status: 'draft',
    allowedPaymentTypes: ['card'],
    currency: 'AUD',
    total: 10000,
    paid: false,
    amountDue: 100000,
    amountPaid: 0,
    metadata: { ref: '123' }
  }
};

export const QUERY = `
  mutation billsCreateOne ($record: AutoFilledCreateOnebillsInput!) {
    billsCreateOne (record: $record) {
        recordId
        record {
            companyId
            invoiceId
            vendorId
            status
            allowedPaymentTypes
            currency
            total
            paid
            amountDue
            amountPaid
            metadata
            _id
            updatedAt
            createdAt
        }
        error {
            message
        }
    }
  }
`;
